<template>
  <section v-if="lang['hotel_mobile_new']">
    <Title :title-name="pageTitle" :title-link="title.SelectRoom.titleLink" />
    <div class="container">
      <div class="my-4">
        <ItemOfVouchers icon="hotel-voucher" color="#f0725e" :label="lang['hotel_mobile_new'].SFS_LANG_ROW_1" border />
      </div>
      <div class="mb-4">
        <HotelCard
          v-if="paxsHotel"
          :hotel-info="paxsHotel"
          :is-after="true"
          :cancel-time="cancelTime"
          :show-cancel-hotel="showCancelHotel"
          :has-cancel-hotel-voucher="!pax.params.has_cancel_hotel_voucher"
          :checkin-date="checkinDate"
          :checkout-date="checkoutDate"
        />
      </div>
    </div>
  </section>
</template>

<script>
import ItemOfVouchers from '@/components/ItemOfVouchers/index'
import HotelCard from '@/components/HotelCard/index'
import Title from '@/components/Title/index'
import { mapGetters } from 'vuex'
import { replaceStr } from '@/utils/helper'
import moment from 'moment'

export default {
  name: 'SelectRoom',
  components: { Title, ItemOfVouchers, HotelCard },
  props: {
    secret: {
      type: String,
      default: ''
    },
    pax_voucher_id: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      nameVoucher: 'Hotel',
      canDownload: false,
      showCancelHotel: false,
      curPaxInfo: null,
      cancelTime: '0',
      checkinDate: null,
      checkoutDate: null
    }
  },
  computed: {
    ...mapGetters({
      paxsHotel: 'SelectRoom/PaxsHotel'
    }),
    pageTitle() {
      const { lang } = this
      return lang && lang.hotel_mobile_new && this.lang.hotel_mobile_new.SFS_LANG_ROW_28
        ? lang.hotel_mobile_new.SFS_LANG_ROW_28
        : 'Home'
    }
  },
  watch: {
    airline: function () {
      this.initData()
    },
    PaxsGroup: function () {
      this.initData()
    },
    pax: function () {
      this.initData()
    },
    paxsHotel: function () {
      this.initData()
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    this.$store.dispatch('SelectRoom/getVoucherHotel', {
      passenger_id: [this.$route.query.pax_voucher_id || this.pax_voucher_id],
      reservation_id: this.$route.query.reservation_id,
      voucher_id: this.$route.query.voucher_id
    })
    this.$store.dispatch('Home/getPaxsGroup')
  },
  methods: {
    replaceStr,
    initData() {
      if (!_.isEmpty(this.airline) && !_.isEmpty(this.PaxsGroup) && !_.isEmpty(this.pax) && !_.isEmpty(this.paxsHotel)) {
        // Get current passenger info
        this.curPaxInfo = this.pax
        if (this.PaxsGroup.length > 1) {
          this.curPaxInfo = _.find(this.PaxsGroup, { passenger_id: parseInt(this.pax?.curPaxID || this.pax?.id) })
        }
        this.canDownload = true

        let isAfterMidNight = 0
        if (typeof this.paxsHotel.isAfterMidNight !== 'undefined') {
          isAfterMidNight = this.paxsHotel.isAfterMidNight
        }

        if (
          !_.isEmpty(this.airline.params) &&
          this.airline.params.enabled_cancel_hotel_mobile == '1' &&
          (_.isNull(this.paxsHotel.ws_type) || this.paxsHotel.ws_type === '')
        ) {
          if (this.paxsHotel.remainTime > 0 && isAfterMidNight === 0) {
            this.showCancelHotel = true
            this.cancelTime = String(this.paxsHotel.remainTime)
            let self = this
            setTimeout(function () {
              self.showCancelHotel = false
              self.cancelTime = '0'
            }, self.paxsHotel.remainTime * 1000)
          }
        }

        this.handleVoucherDate(this.curPaxInfo)

        if (this.PaxsGroup.length) {
          const filteredPax = _.find(this.PaxsGroup, {
            passenger_id: parseInt(this.$route.query.pax_voucher_id || this.pax_voucher_id)
          })
          if (filteredPax?.more_night) {
            this.paxsHotel.more_night = filteredPax.more_night
          }
        }
      }
    },
    handleVoucherDate(paxInfo) {
      if (_.isEmpty(paxInfo)) return false

      let paxReservations = paxInfo?.more_night || []

      if (!paxReservations.length) {
        const paxId = paxInfo?.id || paxInfo?.passenger_id
        paxReservations = this.PaxsGroup.find((pax) => pax.passenger_id === paxId)?.more_night || []
      }

      if (paxReservations.length) {
        const listReservation = paxReservations.map((item) => item.blockdate)
        listReservation.sort((a, b) => new Date(a) - new Date(b))

        this.checkinDate = moment(listReservation[0]).toDate()
        this.checkoutDate = moment(listReservation[listReservation.length - 1])
          .add(1, 'days')
          .toDate()
      }
    }
  }
}
</script>
